export default {
  vote: {
    vote: 'Vote',
    noVoteQuestionsAvailable: 'No vote questions available',
    yes: 'Yes',
    no: 'No',
    noVote: 'Abstain',
    'no vote': 'Abstain',
    null: 'No Vote',
    submit: 'Submit',
    voteResults: 'Vote Results',
    question: 'Question',
    excluded: 'Excluded',
    clause: 'Clause',
    excludedUser: 'You are excluded from this clause',
    voteResultsByShareholder: 'Vote Results by Shareholder',
    noResults: 'No results available',
    name: 'Name',
    download: 'Download',
    votingResultsByShareholder: 'Voting Results by Shareholder',
    next: 'Next',
    meetings: 'Meetings',
    meetingDetails: 'Meeting Details',
    pointDescription: 'Point Description',
    showVoteByOwnership: 'Show vote by ownership',
    showVoteByMember: 'Show vote by member',
    voteCount: 'Vote count',
    totalShares: 'Total shares',
    ownership: 'Ownership',
    voteDetails: 'Vote details',
    shareholder: 'Shareholder',
    shareholders: 'Shareholders',
    results: 'Results',
    percentage: 'Percentage',
  },
};
